<h2>Fleets <button class="icon--add btn--default" type="button" *ngIf="displayResults" (click)="popupCreateFleetModal()">Add New Fleet</button></h2>
<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<p-table #dt [value]="fleets" styleClass="p-datatable-striped">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="6">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="expirationDate" class="w--date">Fleet Exp<p-sortIcon field="expirationDate"></p-sortIcon></th>
            <th pSortableColumn="lastRenewalDate">Date Last Renewed<p-sortIcon field="lastRenewalDate"></p-sortIcon></th>
            <th pSortableColumn="fleetVehicleCount">Vehicles in Fleet<p-sortIcon field="businessTransactionCompletionDate"></p-sortIcon></th>
            <th pSortableColumn="fleetTypeId">Fleet Type<p-sortIcon field="businessTransactionCompletionDate"></p-sortIcon></th>
            <th pSortableColumn="fleetStatusTypeId">Status<p-sortIcon field="businessTransactionCompletionDate"></p-sortIcon></th>
            <th class="w--icon">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{ data.expirationDate | shortDate }}</td>
            <td>{{ data.lastRenewalDate | shortDate }}</td>
            <td>{{ data.fleetVehicleCount }}</td>
            <td>{{ getValues(data.fleetTypeId, fleetType) }}</td>
            <td>{{ getValues(data.fleetStatusTypeId, fleetStatusType) }}</td>
            <td>
                <a *ngIf="showEdit" class="icon--edit" title="Edit Fleet" href="javascript:void(0)" (click)="emitFleetSelection(data.id)"></a>
                <a *ngIf="showResetExpirationDate" class="icon--renew" title="Reset Fleet Expiration" href="javascript:void(0)" (click)="resetFleetExpirationDate(data)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>